// extracted by mini-css-extract-plugin
module.exports = {"accounts":"footer_accounts__23fQN","footer-bg":"footer_footer-bg__1PNzW"};